import api from 'base/utils/api';
import { IServerClientKeys } from './interface';

// 获取client key
export function getServerClientKeys(): Promise<IServerClientKeys> {
    return api.get('/web/locale/client/keys')
}

